export const publicRuntimeConfig = {
  titlePrefix: 'Shoplive',
  apiMatrixEndpoint: process.env.REACT_APP_API_MATRIX_ENDPOINT || 'http://localhost:5530/api',
  apiEndpointOverride: process.env.REACT_APP_API_ENDPOINT_OVERRIDE,
  phase: process.env.REACT_APP_PHASE,
};
